import { type ReportsTranslations } from './reports.translations.pl.ts';

export const reportsTranslations: ReportsTranslations = {
  contents: 'Contenu',
  dashboardPdf: {
    button: 'Imprimer / enregistrer en PDF',
    contents:
      'Chiffres clés et entonnoir · carte des voïvodies · arrivée des candidats · résultats du quiz · compétences',
    description:
      'Les graphiques, la carte et les chiffres clés du recrutement, prêts à imprimer ou à enregistrer en PDF pour les partager.',
    hint: "Dans la fenêtre d'impression, choisissez « Enregistrer au format PDF ».",
    scope: 'Tableau de bord de la période choisie',
    title: 'Tableau de bord en PDF',
  },
  downloadError: 'Une erreur est survenue lors du téléchargement du rapport. Veuillez réessayer.',
  formats: {
    excel: 'Excel',
    pdf: 'PDF',
  },
  fullExport: {
    contents:
      'Données du formulaire · score au quiz et statut · consentements · une feuille séparée avec les compétences',
    description:
      "Tout ce que nous savons des candidats. Un fichier volumineux est préparé en arrière-plan : vous pouvez fermer l'onglet, il sera téléchargé à votre retour dans le panneau.",
    downloadFailed: 'Impossible de télécharger le fichier généré. Veuillez réessayer.',
    downloading: 'Téléchargement du fichier généré…',
    generating: 'Préparation du fichier en arrière-plan…',
    retry: 'Réessayer',
    scope: 'Candidats inscrits pendant la période choisie',
    start: 'Préparer le fichier Excel',
    startFailed: "Impossible de lancer l'export. Veuillez réessayer.",
    stopTracking: 'Arrêter le suivi',
    title: 'Export complet des candidats',
  },
  heading: 'Rapports',
  period: {
    all: 'Tout le recrutement',
    custom: 'Période personnalisée',
    days30: '30 jours',
    days7: '7 jours',
    days90: '90 jours',
    from: 'Du',
    invalid: 'La date de début ne peut pas être postérieure à la date de fin.',
    label: 'Période des rapports',
    sinceStart: 'Depuis le début du recrutement',
    to: 'Au',
  },
  quizResults: {
    button: 'Télécharger le fichier Excel',
    contents: 'Adresse e-mail · points · date de fin du quiz',
    description: 'Les candidats qui ont terminé le quiz, avec les points obtenus.',
    scope: 'Quiz terminés pendant la période choisie',
    title: 'Résultats du quiz',
  },
  subtitle:
    'Les données du recrutement pour Excel et un tableau de bord prêt à imprimer : pour tout le recrutement ou une période choisie',
  summary: {
    candidates: 'Candidats inscrits',
    hint: 'Candidats inscrits pendant cette période, comptés comme dans le tableau de bord.',
    quizzesFinished: 'Ont terminé le quiz',
    recommended: 'Recommandés',
    title: 'Pendant la période choisie',
  },
};
